import axios from "./axios";

/** Normalize API error payloads (string arrays or JSON:API error objects). */
export function formatCommunityReportApiError(data, fallback = "Could not submit report") {
  if (!data) return fallback;

  const raw = data.errors ?? data.error;
  if (raw != null) {
    const list = Array.isArray(raw) ? raw : [raw];
    const messages = list
      .map((item) => {
        if (item == null || item === "") return "";
        if (typeof item === "string") return item;
        if (typeof item === "object") {
          return item.detail || item.title || item.message || "";
        }
        return String(item);
      })
      .filter(Boolean);
    if (messages.length > 0) return messages.join(" ");
  }

  if (typeof data.message === "string" && data.message.trim() !== "") {
    return data.message;
  }

  return fallback;
}

export async function fetchCommunityReports(params = {}) {
  const res = await axios.get("/platform_community_reports", { params });
  return res.data;
}

/** Public ideas feed: votable queue plus approved/in-progress ideas stay visible. */
export async function fetchCommunityVoteFeed({ perPage = 50 } = {}) {
  const res = await axios.get("/platform_community_reports", {
    params: {
      feed: "votes",
      include_approved: 1,
      per_page: perPage,
    },
  });
  return res.data;
}

export async function createCommunityReport(payload, screenshotFile = null) {
  if (screenshotFile) {
    const formData = new FormData();
    Object.entries(payload).forEach(([key, value]) => {
      if (value != null && value !== "") {
        formData.append(`platform_community_report[${key}]`, value);
      }
    });
    formData.append("platform_community_report[page_path]", window.location.pathname);
    formData.append("platform_community_report[screenshot]", screenshotFile);

    const res = await axios.post("/platform_community_reports", formData);
    return res.data;
  }

  const res = await axios.post("/platform_community_reports", {
    platform_community_report: {
      ...payload,
      page_path: window.location.pathname,
    },
  });
  return res.data;
}

export async function voteCommunityReport(id) {
  const res = await axios.post(`/platform_community_reports/${id}/vote`);
  return res.data;
}
